import * as types from '../actions/types';


export default function addOnReducer(state = [], action) {
  switch (action.type) {
    case types.RECEIVE_ADDONS_RESULT:
      return action.addOns;
    default:
      return state;
  }
}
